import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { type MenuSkeletonItemProps } from '../../../types';

import { MenuSkeletonItem } from './MenuSkeletonItemV1';
import { MenuSkeletonItemV2 } from './MenuSkeletonItemV2';

export const SkeletonItem = (props: MenuSkeletonItemProps) => {
	return fg('navx-963-new-loading-skeleton-uc') ? (
		<MenuSkeletonItemV2 {...props} />
	) : (
		<MenuSkeletonItem {...props} />
	);
};
